import { Model, ModelAttributes, collection, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import Funder from "./Funder";
import FundingAppeal from "./FundingAppeal";
import FundingOutreach from "./FundingOutreach";
import FundingScoutProspectSource from "./FundingScoutProspectSource";
import FundingScoutRun from "./FundingScoutRun";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    angle: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    confidence: {
      type: "enum",
      enumType: "high" as Database["public"]["Enums"]["funding_scout_confidence"],
    },
    converted_funder_id: {
      type: "string",
    },
    converted_funding_outreach_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    decision: {
      type: "enum",
      enumType: "added" as Database["public"]["Enums"]["funding_scout_prospect_decision"],
    },
    decision_at: {
      type: "datetime",
    },
    decision_by_account_user_id: {
      type: "string",
    },
    fit_score: {
      type: "number",
    },
    funding_appeal_id: {
      type: "string",
    },
    funding_scout_run_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    name: {
      type: "string",
    },
    next_action: {
      type: "string",
    },
    prospect_key: {
      type: "string",
    },
    prospect_type: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["funding_scout_prospect_type"],
    },
    reason: {
      type: "string",
    },
    stage: {
      type: "enum",
      enumType: "suggested" as Database["public"]["Enums"]["funding_scout_prospect_stage"],
    },
    updated_at: {
      type: "datetime",
    },
  },
  {
    sources: collection(() => FundingScoutProspectSource as any, "funding_scout_prospect_id"),
  },
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    converted_funder: reference(() => Funder as any, "converted_funder_id"),
    converted_funding_outreach: reference(() => FundingOutreach as any, "converted_funding_outreach_id"),
    decision_by_account_user: reference(() => AccountUser as any, "decision_by_account_user_id"),
    funding_appeal: reference(() => FundingAppeal as any, "funding_appeal_id"),
    funding_scout_run: reference(() => FundingScoutRun as any, "funding_scout_run_id"),
  },
);

interface FundingScoutProspect extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_scout_prospects", config)
class FundingScoutProspect extends Model<typeof config> {}

export default FundingScoutProspect;
